<ngx-simplebar class="px-3 mx-n3 mb-2 ai-advertisement-scroll"
  [options]="{ forceVisible: true }">
  <form [formGroup]="propertyAdvertisementForm" *ngIf="dataToFormInitAdvertisement && isView" #formElementRef>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 status-advert">
                <div class="row">
                  <ng-container *ngFor="let option of dataToFormInitAdvertisement?.options">
                  <div class="col-lg-3" *ngIf="isOptionVisible(option)">
                    <div class="mb-3">
                      <div class="form-check form-switch form-switch-primary form-switch-md">
                        <input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck{{ option.id }}"
                          checked formControlName="option{{ option.id }}"
                          [attr.disabled]="(option.order === 0 && isActive.getValue() > 0) || !checkPermissionsByOption(option) ? true : null" />
                        <label container="body"
                          [ngbTooltip]="!checkPermissionsByOption(option) ? ('t-no-permission' | translate) : null"
                          class="form-check-label" for="SwitchCheck{{ option.id }}">
                          {{ option.name }}
                        </label>
                      </div>
                    </div>
                  </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="ai-result-panel" *ngIf="canShowAiOptions && aiLatestResult as latest">
              <div class="ai-result-panel__icon"
                [ngClass]="{
                  'is-title': latest.kind === 'TITLE',
                  'is-description': latest.kind === 'DESCRIPTION',
                  'is-translation': latest.kind === 'TRANSLATION'
                }">
                <i class="ri-magic-line" *ngIf="latest.kind !== 'TRANSLATION'"></i>
                <i class="ri-translate-2" *ngIf="latest.kind === 'TRANSLATION'"></i>
              </div>
              <div class="ai-result-panel__body">
                <strong>{{ latest.headline }}</strong>
                <p class="mb-0 text-muted" *ngIf="latest.detail">{{ latest.detail }}</p>
                <small *ngIf="latest.preview">"{{ latest.preview }}"</small>
              </div>
            </div>

            <div class="row mt-2" *ngIf="dataToFormInitAdvertisement?.langs?.length > 0">
              <div class="col-12">
                <ul ngbNav #Arrow="ngbNav" [activeId]="activeTabSubject$.getValue()"
                  (activeIdChange)="activeIdChangeNabTab($event)" class="nav ai-lang-nav">
                  <li [ngbNavItem]="i + 1" *ngFor="let lang of dataToFormInitAdvertisement?.langs; index as i">
                    <a ngbNavLink class="ai-lang-card" [class.is-main]="isMainLanguage(lang)">
                      <div class="ai-lang-card__top">
                        <img class="ai-lang-card__flag" [src]="getLangFlag(lang)" [alt]="getLangCode(lang)" />
                        <strong>{{ getLangCode(lang) }}</strong>
                      </div>
                      <div class="ai-lang-card__bottom">
                        <span>{{ getLangName(lang) }}</span>
                        <span class="ai-lang-badge is-main" *ngIf="isMainLanguage(lang)">
                          {{ 'ai-advertisement.mainBadge' | translate }}
                        </span>
                        <span class="ai-lang-badge" *ngIf="!isMainLanguage(lang) && isTranslatedLanguage(lang)">
                          {{ 'ai-advertisement.translatedBadge' | translate }}
                        </span>
                        <span class="ai-lang-badge is-pending" *ngIf="!isMainLanguage(lang) && isPendingTranslationLanguage(lang)">
                          {{ 'ai-advertisement.pendingBadge' | translate }}
                        </span>
                      </div>
                    </a>

                    <ng-template ngbNavContent>
                      <div class="ai-content-card">
                        <div class="ai-title-row">
                          <div class="ai-title-row__field">
                            <label class="form-label text-body" for="property-title-lang{{ lang.id }}-input">
                              {{ 't-m-properties.t-property-title' | translate }}
                              <span style="text-transform: uppercase;">({{ lang.lang }})</span>
                            </label>
                            <input type="text" class="form-control" required id="property-title-lang{{ lang.id }}-input"
                              placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-property-title' | translate }}"
                              [ngClass]="{
                                'is-warning': submitted && hasWarning('lang' + lang.id + '_title'),
                                'ai-filling': aiFillingFields['title_' + lang.id]
                              }" formControlName="lang{{ lang.id }}_title" />
                            <div class="ai-title-meta">
                              <small>{{ getTitleLength(lang) }} / {{ titleSoftLimit }}</small>
                            </div>
                          </div>

                          <div class="ai-title-row__actions">
                            <div class="form-check form-switch form-switch-md form-switch-primary">
                              <input class="form-check-input opacity-100" type="checkbox" role="switch"
                                id="SwitchCheckManin{{ lang.id }}" formControlName="lang{{ lang.id }}_main"
                                (change)="onChangeMainLang(lang.id)"
                                [attr.disabled]="(propertyAdvertisementForm.get('lang' + lang.id + '_main')?.value === true && !hasWarning('lang' + lang.id + '_title')) || hasWarning('lang' + lang.id + '_title') ? true : null" />
                              <label class="form-check-label text-body opacity-100" for="SwitchCheckManin{{ lang.id }}">
                                {{ 't-m-properties.t-main-language' | translate }}
                                <span style="text-transform: uppercase;">({{ lang.lang }})</span>
                              </label>
                            </div>
                          </div>
                        </div>

                        <div class="ai-description-row">
                          <div class="ai-description-row__editor">
                            <label class="ai-desc-toolbar-label text-body">
                              {{ 't-m-properties.t-property-description' | translate }}
                              <span style="text-transform: uppercase;">({{ lang.lang }})</span>
                            </label>
                            <div class="ckeditor-wrapper"
                              [ngClass]="{
                                'is-warning': submitted && hasWarning('lang' + lang.id + '_description'),
                                'ai-filling': aiFillingFields['desc_' + lang.id]
                              }">
                              <ckeditor [editor]="lang.lang == 'pt' ? editorPT : editorEN"
                                formControlName="lang{{ lang.id }}_description">
                                {{ 't-m-properties.t-placeholder-property-description' | translate }}
                              </ckeditor>
                            </div>
                            <div class="ai-description-feedback" [ngClass]="getDescriptionFeedbackClass(lang)">
                              <span>{{ getDescriptionTextLength(lang) }} {{ 'ai-advertisement.characters' | translate }}</span>
                              <span>{{ getDescriptionFeedbackKey(lang) | translate }}</span>
                            </div>
                          </div>

                          <div class="ai-description-row__actions" *ngIf="canShowAiOptions">
                            <div class="ai-credit-pop-wrapper"
                              [ngbTooltip]="getGenerateTitleTooltip(lang)"
                              [disableTooltip]="!getGenerateTitleTooltip(lang)"
                              container="body" placement="top">
                              <button type="button" class="ai-action-btn" (click)="generateTitle(lang)"
                                [disabled]="isGenerateTitleDisabled(lang)">
                                <span class="spinner-border spinner-border-sm" *ngIf="aiLoading['title_'+lang.id]"></span>
                                <i class="ri-magic-line" *ngIf="!aiLoading['title_'+lang.id]"></i>
                                <span>{{ 'ai-advertisement.generateTitle' | translate }}</span>
                                <span class="ai-action-cost">{{ isAiServiceFree('LISTING_TITLE') ? ('ai-advertisement.freeFirstUse' | translate) : getAiServiceCost('LISTING_TITLE') + ' cr' }}</span>
                              </button>
                              <span class="ai-credit-pop" *ngIf="aiCreditPops['title_' + lang.id]">{{ aiCreditPops['title_' + lang.id].text }}</span>
                            </div>

                            <div class="ai-credit-pop-wrapper"
                              [ngbTooltip]="getGenerateDescriptionTooltip(lang)"
                              [disableTooltip]="!getGenerateDescriptionTooltip(lang)"
                              container="body" placement="top">
                              <button type="button" class="ai-action-btn" (click)="generateDescription(lang)"
                                [disabled]="isGenerateDescriptionDisabled(lang)">
                                <span class="spinner-border spinner-border-sm" *ngIf="aiLoading['desc_'+lang.id]"></span>
                                <i class="ri-file-edit-line" *ngIf="!aiLoading['desc_'+lang.id]"></i>
                                <span>{{ 'ai-advertisement.generateDescription' | translate }}</span>
                                <span class="ai-action-cost">{{ getAiServiceCost('LISTING_DESCRIPTION') }} cr</span>
                              </button>
                              <span class="ai-credit-pop" *ngIf="aiCreditPops['desc_' + lang.id]">{{ aiCreditPops['desc_' + lang.id].text }}</span>
                            </div>

                            <div class="ai-credit-pop-wrapper"
                              [ngbTooltip]="getTranslateTooltip()"
                              [disableTooltip]="!getTranslateTooltip()"
                              container="body" placement="top">
                              <button type="button" class="ai-action-btn ai-action-btn--translate"
                                (click)="translateContent()"
                                [disabled]="isTranslateDisabled()">
                                <span class="spinner-border spinner-border-sm" *ngIf="aiLoading['translate']"></span>
                                <i class="ri-translate-2" *ngIf="!aiLoading['translate']"></i>
                                <span>{{ 'ai-advertisement.translate' | translate }}</span>
                                <span class="ai-action-cost">{{ getAiServiceCost('TRANSLATION') }} cr</span>
                              </button>
                              <span class="ai-credit-pop" *ngIf="aiCreditPops['translate']">{{ aiCreditPops['translate'].text }}</span>
                            </div>

                            <small class="ai-service-state" [class.is-on]="canUseAiService('LISTING_TITLE')">
                              {{ canUseAiService('LISTING_TITLE') ? ('ai-advertisement.serviceOn' | translate) : ('ai-advertisement.serviceOff' | translate) }}
                            </small>
                            <div class="ai-security-note">
                              <strong>{{ 'ai-feedback.securityNoticeTitle' | translate }}</strong>
                              <span>{{ 'ai-feedback.securityNoticeBody' | translate }}</span>
                            </div>
                          </div>
                        </div>

                        <div class="ai-translation-flow" *ngIf="canShowAiOptions && (aiLoading['translate'] || aiTranslationPulse)"
                          [class.is-done]="!aiLoading['translate'] && aiTranslationPulse">
                          <span class="dot"></span>
                          <span class="dot"></span>
                          <span class="dot"></span>
                          <span class="label">
                            {{ aiLoading['translate'] ? ('ai-feedback.translationRunning' | translate) : ('ai-feedback.translationApplied' | translate) }}
                          </span>
                        </div>
                      </div>
                    </ng-template>
                  </li>
                </ul>

                <div class="tab-content text-muted">
                  <div [ngbNavOutlet]="Arrow"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ngx-simplebar>
